<script setup>
import { h, isVNode } from 'vue';
import PhosphorSvg from 'shared/components/icon/PhosphorSvg.vue';
import { isStoredPhosphorIcon } from 'shared/helpers/phosphorIcons';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  // Help Center persists picker output as "i-ph-<name>;<color>". Those names are
  // not in the Tailwind content scan, so render them as inline SVG. Plain
  // "i-ph-<name>" literals in source files keep using their CSS class.
  if (isStoredPhosphorIcon(props.icon)) {
    return h(PhosphorSvg, { icon: props.icon });
  }
  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
